import { LoaderFunctionArgs } from 'react-router-dom';
import { fetchWarehouseIncome } from '../WarehouseIncomesPage/services';

export const warehouseIncomePageLoader = async ({
  params,
}: LoaderFunctionArgs) => {
  const id = String(params.id);

  if (id === 'new') return { data: null };

  try {
    const data = await fetchWarehouseIncome({ id });
    return { data: data ?? null };
  } catch {
    return { data: null };
  }
};
